import { useMemo } from "react";
import { useTable } from "react-table";
import { convertToTilteCase, defaultDateDisplay } from "../../../helpers";
import styles from "./styles.module.scss";

const useStockRemovalItemsTable = ({
  items: itemsProp,
  removalDetails,
  setPreviewImage = () => {},
  onPreviewImage,
}) => {
  const items = useMemo(
    () => itemsProp || removalDetails?.items || [],
    [itemsProp, removalDetails?.items],
  );

  const handleImageClick = (imgUrl) => {
    if (onPreviewImage) {
      onPreviewImage(imgUrl);
    } else if (setPreviewImage) {
      setPreviewImage(imgUrl);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: (_row, i) => i + 1,
        id: "index",
        Cell: ({ row }) => <span>{row.index + 1}</span>,
      },
      {
        Header: "Product Name",
        accessor: "product_name",
        Cell: ({ cell: { value } }) => (
          <span className="font-weight-medium">{value || "Product"}</span>
        ),
      },
      {
        Header: "Variant",
        accessor: "variant_name",
        Cell: ({ cell: { value } }) => <span>{value || "-"}</span>,
      },
      {
        Header: "Quantity",
        accessor: "quantity",
        Cell: ({ cell: { value } }) => <span>{value ?? "-"}</span>,
      },
      {
        Header: "Tracking IDs",
        accessor: "item_ids",
        Cell: ({ cell: { value } }) => (
          <span>
            {Array.isArray(value) && value.length > 0 ? value.join(", ") : "-"}
          </span>
        ),
      },
      {
        Header: "Reason",
        accessor: "reason",
        Cell: ({ cell: { value }, row }) => (
          <span>
            {row?.original?.reason_display ||
              (value ? convertToTilteCase(value.replace(/_/g, " ")) : "-")}
          </span>
        ),
      },
      {
        Header: "Description",
        accessor: "description",
        Cell: ({ cell: { value } }) => <span>{value || "-"}</span>,
      },
      {
        Header: "Expiry Date",
        accessor: "expiry_date",
        Cell: ({ cell: { value } }) => <span>{defaultDateDisplay(value)}</span>,
      },
      {
        Header: "Evidence Images",
        accessor: "images",
        Cell: ({ cell: { value } }) => {
          if (Array.isArray(value) && value.length > 0) {
            return (
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                {value.map((imgUrl, imgIdx) => (
                  <img
                    key={imgIdx}
                    src={imgUrl}
                    alt={`evidence-${imgIdx}`}
                    className={styles.evidenceImg}
                    onClick={() => handleImageClick(imgUrl)}
                  />
                ))}
              </div>
            );
          }
          return (
            <span style={{ color: "#A0AEC0", fontSize: "12px" }}>
              No evidence
            </span>
          );
        },
      },
    ],
    [onPreviewImage, setPreviewImage],
  );

  const instance = useTable({
    columns,
    data: items,
  });

  return {
    instance,
    items,
    handleImageClick,
  };
};

export default useStockRemovalItemsTable;
